import React from 'react';
import { connect } from 'react-redux';
import { desktopDoc } from '~routes/login-page/svgs';
import Login from './login';
import './style.scss';

function LawsLanding({ isMobile }) {
    console.log('+++LANDING+++');
    const isTTSu = window.location.host === 'tracktrack.su';
    return (
        <div className="login-page">
            <Login />
            {!isMobile && isTTSu && (
                <div className="login-page__rzd-header">
                    <h1>
                        Информационно-
                        <br /> аналитический портал
                    </h1>
                    <h3>
                        Мониторинг новостей и проектов нормативно-правовых актов с помощью искусственного интеллекта
                    </h3>
                </div>
            )}
            {!isMobile && !isTTSu && (
                <div className="login-page__main-header">
                    <h1>
                        Правовой
                        <br /> модуль TrackTrack
                    </h1>
                    <h3>Мониторинг проектов нормативно-правовых актов с помощью искусственного интеллекта</h3>
                    <a href="/docs/TrackTrackPresentation.pdf" download className="login-page__file">
                        {desktopDoc}
                        <span className="login-page__file-text">Скачать презентацию</span>
                    </a>
                </div>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
});

export default connect(mapStateToProps)(LawsLanding);



// WEBPACK FOOTER //
// ./src/routes/login-page/index.js